import Axios from 'axios';

export function axiosCancelRequestSource() {
  return Axios.CancelToken.source();
}
